export default "__VITE_ASSET__0c7ee19c__"